var _g, _path, _g2, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_48649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3438 22.0939C12.4209 22.0939 15.6876 18.8258 15.6876 14.7501C15.6876 10.6743 12.4209 7.40625 8.3438 7.40625C4.26808 7.40625 1 10.6743 1 14.7501C1 18.8258 4.26808 22.0939 8.3438 22.0939Z",
    fill: "#C4C4C4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34138 11.9961L8.95957 13.8987H10.9601L9.34164 15.0746L9.95983 16.9772L8.34138 15.8013L6.72292 16.9772L7.34111 15.0746L5.72266 13.8987H7.72318L8.34138 11.9961Z",
    fill: "#D9D9D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1072_48649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1934 22.0939C25.2705 22.0939 28.5372 18.8258 28.5372 14.7501C28.5372 10.6743 25.2705 7.40625 21.1934 7.40625C17.1177 7.40625 13.8496 10.6743 13.8496 14.7501C13.8496 18.8258 17.1177 22.0939 21.1934 22.0939Z",
    fill: "#C4C4C4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 23,
    width: 26,
    height: 3,
    rx: 1.5,
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_48649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6876,
    height: 14.6876,
    fill: "white",
    transform: "translate(1 7.40625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1072_48649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6876,
    height: 14.6876,
    fill: "white",
    transform: "translate(13.8496 7.40625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/Token.68f5af2f0e5d79c6c1c9f83b4012b23d.svg";
export { ForwardRef as ReactComponent };